module.exports = __webpack_public_path__ + "static/ssb-day-final-c00db6753bf3f2aa5c0588ab3cbedefc.png";